<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf" id="rintro"><a class="xref" href="#/chiwomack0007#intro">Introduction: Data and the Matter of Black Life</a></p>
<p class="toc1" id="rahaftintro01"><a class="xref" href="#/chiwomack0007#ahaftintro01">Undisciplining Data</a></p>
<p class="toc1" id="rahintro01"><a class="xref" href="#/chiwomack0007#ahintro01">The Social Life of Racial Data</a></p>
<p class="toc1" id="rahintro02"><a class="xref" href="#/chiwomack0007#ahintro02">Racial Data, Visual Revolutions</a></p>
<p class="toc1" id="rahintro03"><a class="xref" href="#/chiwomack0007#ahintro03">The Aesthetics of Data</a></p>
<p class="toc1" id="rahintro04"><a class="xref" href="#/chiwomack0007#ahintro04">Undisciplining as Method</a></p>
<p class="toc1" id="rahintro05"><a class="xref" href="#/chiwomack0007#ahintro05">Overview</a></p>
<p class="toc" id="rch01"><a class="xref" href="#/chiwomack0008#ch01">1 · The Social Survey: The Survey Spirit</a></p>
<p class="toc1" id="rahaft0101"><a class="xref" href="#/chiwomack0008#ahaft0101">“The Survey Spirit”: Origins, Evolution, and the Radical Operations of the Social Survey</a></p>
<p class="toc1" id="rah0101"><a class="xref" href="#/chiwomack0008#ah0101">“Ugly Facts” and (Anti)Social Data: Kelly Miller, the American Negro Academy, and the Call for the Social Survey</a></p>
<p class="toc1" id="rah0102"><a class="xref" href="#/chiwomack0008#ah0102">A Book to Do Some Good: Kelly Miller, Sutton Griggs, and the Emergence of Social Document Fiction</a></p>
<p class="toc1" id="rah0103"><a class="xref" href="#/chiwomack0008#ah0103">Faulty Surfaces, Unruly Eyes</a></p>
<p class="toc1" id="rah0104"><a class="xref" href="#/chiwomack0008#ah0104">Everywhere and Nowhere: The Social Survey’s Nongeography</a></p>
<p class="toc" id="rch02"><a class="xref" href="#/chiwomack0009#ch02">2 · Photography: Looking Out</a></p>
<p class="toc1" id="rahaft0201"><a class="xref" href="#/chiwomack0009#ahaft0201">Seeing Survival</a></p>
<p class="toc1" id="rah0201"><a class="xref" href="#/chiwomack0009#ah0201">Deep Black Mourning: Lynching’s (Anti)Photographic Logic</a></p>
<p class="toc1" id="rah0202"><a class="xref" href="#/chiwomack0009#ah0202">“Let Them See”: Photography, Performance, and Reform</a></p>
<p class="toc1" id="rah0203"><span aria-label="viii" class="page" id="pviii" role="doc-pagebreak"></span><a class="xref" href="#/chiwomack0009#ah0203">Looking Out: Toward a New Visual Epistemology of Survival</a></p>
<p class="toc1" id="rah0204"><a class="xref" href="#/chiwomack0009#ah0204">Photographically Hesitant: The Visual Politics of W. E. B. Du Bois’s “Jesus Christ in Georgia”</a></p>
<p class="toc" id="rch03"><a class="xref" href="#/chiwomack0010#ch03">3 · Film: Overexposure</a></p>
<p class="toc1" id="rahaft0301"><a class="xref" href="#/chiwomack0010#ahaft0301">Beyond the Frame: Overexposure and Zora Hurston’s Filmic Practice</a></p>
<p class="toc1" id="rah0301"><a class="xref" href="#/chiwomack0010#ah0301">“Drenched in Light”</a></p>
<p class="toc1" id="rah0302"><a class="xref" href="#/chiwomack0010#ah0302">Recording Racial Feeling</a></p>
<p class="toc1" id="rah0303"><a class="xref" href="#/chiwomack0010#ah0303">Contraband Flesh</a></p>
<p class="toc1" id="rah0304"><a class="xref" href="#/chiwomack0010#ah0304">Cinematics of Negro Expression</a></p>
<p class="tocf" id="rcoda"><a class="xref" href="#/chiwomack0011#coda">Coda: Racial Data’s Afterlives</a></p>
<p class="tocf" id="rplates"><a class="xref" href="#/chiwomack0012#plates">Color plates</a></p>
<p class="tocbmf" id="racknow"><a class="xref" href="#/chiwomack0013#acknow">Acknowledgments</a></p>
<p class="tocbm" id="rnotes"><a class="xref" href="#/chiwomack0014#notes">Notes</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/chiwomack0015#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-womack-0006.vue?a1aaf4cc